const read = (startRead) => (file) => {
  const fileReader = new FileReader()

  return new Promise((resolve, reject) => {
    fileReader.onerror = () => {
      fileReader.abort()
      reject(new Error('Failed to certificate file'))
    }

    fileReader.onload = () => {
      resolve(fileReader.result)
    }

    startRead(fileReader, file)
  })
}

const readAsText = read((reader, file) => reader.readAsText(file))
const readAsArrayBuffer = read((reader, file) => reader.readAsArrayBuffer(file))

const base64Encode = (arrayBuffer) => btoa(String.fromCharCode(...new Uint8Array(arrayBuffer)))

const splitEvery = (n) => (str) => str.match(new RegExp(`.{1,${n}}`, 'g'))
const split64 = splitEvery(64)

const CertHeader = '-----BEGIN CERTIFICATE-----'
const CertFooter = '-----END CERTIFICATE-----'

const encodeCertificate = (raw) => `${[CertHeader, ...split64(base64Encode(raw)), CertFooter].join('\n')}\n`

const isEncodedCertificate = (raw) => raw.match(new RegExp(`^${CertHeader}`))

export const readAsBase64 = async (file) => {
  const certificateText = await readAsText(file)

  if (isEncodedCertificate(certificateText)) return certificateText

  const certificateBuffer = await readAsArrayBuffer(file)
  return encodeCertificate(certificateBuffer)
}
